import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=0b64dda0&scoped=true&"
import script from "./AppToolbar.vue?vue&type=script&lang=js&"
export * from "./AppToolbar.vue?vue&type=script&lang=js&"
import style0 from "./AppToolbar.vue?vue&type=style&index=0&id=0b64dda0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b64dda0",
  null
  
)

export default component.exports